import React from "react";
import styles from "./Ethical.module.scss";
import Image from "next/image";
function Ethical(props: any) {
  return (
    <div className={styles["ethical-wrapper"]}>
      <div className={styles["ethical-wrapper-image"]}>
        <Image
          src={props.image}
          alt=""
          height={200}
          width={400}
          className={styles["ethical-image"]}
        />
      </div>
      <div className={styles["ethical-wrapper-content"]}>
        <h3>{props.title}</h3>
        <h2>{props.subTitle}</h2>
        <p>{props.text}</p>
      </div>
    </div>
  );
}

export default Ethical;
